(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-editorial-journal"] && !Shopify.designMode) return;
  try {
    
  const initializeBlogArchive = (scope = document) => {
    scope.querySelectorAll('[data-blog-archive]').forEach((archive) => {
      if (archive.dataset.initialized === 'true') return;
      archive.dataset.initialized = 'true';

      const section = archive.closest('.blog-journal');
      const feature = section.querySelector('[data-blog-feature]');
      const cards = [...section.querySelectorAll('[data-blog-card]')];
      const items = [feature, ...cards].filter(Boolean);
      const yearsContainer = archive.querySelector('[data-blog-archive-years]');
      const reset = archive.querySelector('[data-blog-archive-reset]');
      const listHeading = section.querySelector('[data-blog-list-heading]');
      const latestHeading = archive.dataset.latestHeading;
      const filteredHeading = archive.dataset.filteredHeading;
      const months = new Map();

      items.forEach((item) => {
        const key = item.dataset.publishedMonth;
        if (!key) return;
        months.set(key, (months.get(key) || 0) + 1);
      });

      const groupedYears = new Map();
      [...months.entries()]
        .sort(([a], [b]) => b.localeCompare(a))
        .forEach(([key, count]) => {
          const [year, month] = key.split('-');
          if (!groupedYears.has(year)) groupedYears.set(year, []);
          groupedYears.get(year).push({ key, month, count });
        });

      groupedYears.forEach((monthItems, year) => {
        const row = document.createElement('div');
        row.className = 'blog-journal__archive-year';
        const heading = document.createElement('h3');
        heading.textContent = year;
        const monthList = document.createElement('div');
        monthList.className = 'blog-journal__archive-months';

        monthItems.forEach(({ key, month, count }) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'blog-journal__archive-month';
          button.dataset.blogMonth = key;
          button.textContent = `${new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'long' }).format(new Date(2000, Number(month) - 1, 1))} (${count})`;
          monthList.appendChild(button);
        });

        row.append(heading, monthList);
        yearsContainer.appendChild(row);
      });

      const applyMonth = (monthKey, updateUrl = true) => {
        const filtering = Boolean(monthKey);
        const defaultCards = cards.slice(0, 6);

        if (feature) feature.hidden = filtering && feature.dataset.publishedMonth !== monthKey;
        cards.forEach((card, index) => {
          if (filtering) {
            card.classList.remove('blog-journal__card--archive-only');
            card.hidden = card.dataset.publishedMonth !== monthKey;
          } else {
            card.classList.toggle('blog-journal__card--archive-only', index >= 6);
            card.hidden = !defaultCards.includes(card);
          }
        });

        archive.querySelectorAll('[data-blog-month]').forEach((button) => {
          const active = button.dataset.blogMonth === monthKey;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        reset.hidden = !filtering;
        if (listHeading) {
          if (filtering) {
            const [year, month] = monthKey.split('-');
            const monthName = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'long' }).format(new Date(2000, Number(month) - 1, 1));
            listHeading.textContent = `${filteredHeading} ${monthName} ${year}`;
          } else {
            listHeading.textContent = latestHeading;
          }
        }

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (filtering) url.searchParams.set('month', monthKey);
          else url.searchParams.delete('month');
          window.history.replaceState({}, '', url);
        }
      };

      archive.addEventListener('click', (event) => {
        const monthButton = event.target.closest('[data-blog-month]');
        if (monthButton) {
          applyMonth(monthButton.dataset.blogMonth);
          section.querySelector('[data-blog-grid]').scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (event.target.closest('[data-blog-archive-reset]')) {
          applyMonth('');
          section.querySelector('[data-blog-grid]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      const initialMonth = new URL(window.location.href).searchParams.get('month');
      applyMonth(months.has(initialMonth) ? initialMonth : '', false);
    });
  };

  initializeBlogArchive();
  document.addEventListener('shopify:section:load', (event) => initializeBlogArchive(event.target));

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-blog-share]');
    if (!button) return;
    const mode = button.dataset.blogShare;
    const url = button.dataset.shareUrl;
    const title = button.dataset.shareTitle;
    const status = button.parentElement.querySelector('[data-share-status]');

    if (mode === 'native' && navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }

    if (navigator.clipboard) {
      await navigator.clipboard.writeText(url);
      if (status) status.textContent = button.dataset.copiedLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-visualizer"] && !Shopify.designMode) return;
  try {
    
  class GalleryVisualizer {
    constructor(root) {
      this.root = root;
      this.range = root.querySelector('[data-comparison-range]');
      this.form = root.querySelector('[data-visualizer-form]');
      this.upload = root.querySelector('[data-room-upload]');
      this.uploadTitle = root.querySelector('[data-room-upload-title]');
      this.productUpload = root.querySelector('[data-product-upload]');
      this.productUploadTitle = root.querySelector('[data-product-upload-title]');
      this.beforeImage = root.querySelector('.gvs__comparison-before .gvs__image');
      this.requirements = root.querySelector('[data-requirements]');
      this.email = root.querySelector('[data-customer-email]');
      this.generate = root.querySelector('[data-generate-preview]');
      this.status = root.querySelector('[data-visualizer-status]');
      this.search = root.querySelector('[data-gallery-search]');
      this.filters = Array.from(root.querySelectorAll('[data-gallery-filter]'));
      this.cards = Array.from(root.querySelectorAll('[data-scene-card]'));
      this.count = root.querySelector('[data-result-count]');
      this.empty = root.querySelector('[data-gallery-empty]');
      this.clear = root.querySelector('[data-clear-filters]');
      this.objectUrl = null;
      this.bind();
      this.filterScenes();
    }

    bind() {
      this.range?.addEventListener('input', () => {
        this.root.querySelector('.gvs__comparison').style.setProperty('--comparison-position', `${this.range.value}%`);
      });

      this.upload?.addEventListener('change', () => this.handleUpload(this.upload, this.uploadTitle, true));
      this.productUpload?.addEventListener('change', () => this.handleUpload(this.productUpload, this.productUploadTitle, false));
      this.form?.addEventListener('submit', (event) => this.handleGenerate(event));
      this.search?.addEventListener('input', () => this.filterScenes());
      this.filters.forEach((filter) => filter.addEventListener('change', () => this.filterScenes()));
      this.clear?.addEventListener('click', () => this.clearFilters());

      this.root.querySelectorAll('[data-favorite]').forEach((button) => {
        button.addEventListener('click', () => {
          const pressed = button.getAttribute('aria-pressed') === 'true';
          button.setAttribute('aria-pressed', String(!pressed));
        });
      });
    }

    handleUpload(input, title, updateRoomPreview) {
      const file = input.files?.[0];
      if (!file) return;

      if (file.size > 20 * 1024 * 1024) {
        this.status.textContent = 'Please choose an image smaller than 20MB.';
        input.value = '';
        return;
      }

      title.textContent = file.name;
      if (updateRoomPreview) {
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = URL.createObjectURL(file);
        this.beforeImage.src = this.objectUrl;
        this.beforeImage.removeAttribute('srcset');
        this.range.value = 100;
        this.root.querySelector('.gvs__comparison').style.setProperty('--comparison-position', '100%');
      }
      this.status.textContent = 'Photo ready. Complete all fields before submitting.';
    }

    async handleGenerate(event) {
      event.preventDefault();

      if (!this.upload.files?.[0]) {
        this.status.textContent = 'Please upload your room photo first.';
        this.upload.focus();
        return;
      }

      if (!this.productUpload.files?.[0]) {
        this.status.textContent = 'Please upload your favorite ceiling tile photo.';
        this.productUpload.focus();
        return;
      }

      if (!this.form.checkValidity()) {
        this.status.textContent = 'Please complete your requirements and delivery email.';
        this.form.reportValidity();
        return;
      }

      const endpoint = this.root.dataset.requestEndpoint;
      if (!endpoint) {
        this.status.textContent = 'Not sent: secure AI generation and email delivery are not connected yet.';
        return;
      }

      this.generate.disabled = true;
      this.generate.classList.add('is-loading');
      this.generate.querySelector('span').textContent = 'Sending request...';
      this.status.textContent = 'Uploading your photos securely...';

      const payload = new FormData(this.form);
      payload.append('company_email', this.root.dataset.companyEmail);

      try {
        const response = await fetch(endpoint, { method: 'POST', body: payload });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.message || 'The request could not be submitted.');
        this.range.value = 50;
        this.root.querySelector('.gvs__comparison').style.setProperty('--comparison-position', '50%');
        this.status.textContent = result.message || 'Request received. The finished preview will be sent to both email addresses.';
      } catch (error) {
        this.status.textContent = `Not sent: ${error.message}`;
        window.turnstile?.reset();
      } finally {
        this.generate.disabled = false;
        this.generate.classList.remove('is-loading');
        this.generate.querySelector('span').textContent = 'Generate my preview';
      }
    }

    filterScenes() {
      const query = this.search?.value.trim().toLowerCase() || '';
      const selected = Object.fromEntries(this.filters.map((filter) => [filter.dataset.galleryFilter, filter.value.toLowerCase()]));
      let visible = 0;

      this.cards.forEach((card) => {
        const searchMatch = !query || card.dataset.search.includes(query);
        const filterMatch = Object.entries(selected).every(([key, value]) => !value || card.dataset[key] === value);
        card.hidden = !(searchMatch && filterMatch);
        if (!card.hidden) visible += 1;
      });

      this.count.textContent = `${visible} scene${visible === 1 ? '' : 's'}`;
      this.empty.hidden = visible !== 0;
    }

    clearFilters() {
      this.search.value = '';
      this.filters.forEach((filter) => {
        filter.value = '';
      });
      this.filterScenes();
      this.search.focus();
    }
  }

  document.querySelectorAll('[data-gallery-visualizer]').forEach((root) => new GalleryVisualizer(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
